// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    client1Stat: {
        type: FIELD_TYPES.TEXT,
        label: "Client 1 Stat",
        translatable: true
    },
    client2Stat: {
        type: FIELD_TYPES.TEXT,
        label: "Client 2 Stat",
        translatable: true
    },
    client3Stat: {
        type: FIELD_TYPES.TEXT,
        label: "Client 3 Stat",
        translatable: true
    },
    client4Stat: {
        type: FIELD_TYPES.TEXT,
        label: "Client 4 Stat",
        translatable: true
    },
    client5Stat: {
        type: FIELD_TYPES.TEXT,
        label: "Client 5 Stat",
        translatable: true
    },
    client6Stat: {
        type: FIELD_TYPES.TEXT,
        label: "Client 6 Stat",
        translatable: true
    },
    mainTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Main Title",
        translatable: true
    },
    tab1NameClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 1 Name Client",
        translatable: true
    },
    tab1QuoteClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 1 Quote Client",
        translatable: true
    },
    tab1Text: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 1 Text",
        translatable: true
    },
    tab1TextButton: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 1 Text Button",
        translatable: true
    },
    tab1Title: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 1 Title",
        translatable: true
    },
    tab1TitleClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 1 Title Client",
        translatable: true
    },
    tab2NameClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 2 Name Client",
        translatable: true
    },
    tab2QuoteClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 2 Quote Client",
        translatable: true
    },
    tab2Text: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 2 Text",
        translatable: true
    },
    tab2TextButton: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 2 Text Button",
        translatable: true
    },
    tab2Title: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 2 Title",
        translatable: true
    },
    tab2TitleClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 2 Title Client",
        translatable: true
    },
    tab3NameClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 3 Name Client",
        translatable: true
    },
    tab3QuoteClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 3 Quote Client",
        translatable: true
    },
    tab3Text: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 3 Text",
        translatable: true
    },
    tab3TextButton: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 3 Text Button",
        translatable: true
    },
    tab3Title: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 3 Title",
        translatable: true
    },
    tab3TitleClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 3 Title Client",
        translatable: true
    },
    tab4NameClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 4 Name Client",
        translatable: true
    },
    tab4QuoteClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 4 Quote Client",
        translatable: true
    },
    tab4Text: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 4 Text",
        translatable: true
    },
    tab4TextButton: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 4 Text Button",
        translatable: true
    },
    tab4Title: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 4 Title",
        translatable: true
    },
    tab4TitleClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 4 Title Client",
        translatable: true
    },
    tab5NameClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 5 Name Client",
        translatable: true
    },
    tab5QuoteClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 5 Quote Client",
        translatable: true
    },
    tab5Text: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 5 Text",
        translatable: true
    },
    tab5TextButton: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 5 Text Button",
        translatable: true
    },
    tab5Title: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 5 Title",
        translatable: true
    },
    tab5TitleClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 5 Title Client",
        translatable: true
    },
    tab6NameClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 6 Name Client",
        translatable: true
    },
    tab6QuoteClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 6 Quote Client",
        translatable: true
    },
    tab6Text: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 6 Text",
        translatable: true
    },
    tab6TextButton: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 6 Text Button",
        translatable: true
    },
    tab6Title: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 6 Title",
        translatable: true
    },
    tab6TitleClient: {
        type: FIELD_TYPES.TEXT,
        label: "Tab 6 Title Client",
        translatable: true
    },
    tab1ClientHeadshot: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 1 Client Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab1ClientLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 1 Client Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab1ImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 1 Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2ClientHeadshot: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 2 Client Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2ClientLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 2 Client Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2ImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 2 Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3ClientHeadshot: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 3 Client Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3ClientLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 3 Client Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3ImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 3 Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4ClientHeadshot: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 4 Client Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4ClientLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 4 Client Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4ImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 4 Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5ClientHeadshot: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 5 Client Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5ClientLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 5 Client Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5ImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 5 Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab6ClientHeadshot: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 6 Client Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab6ClientLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 6 Client Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab6ImageUrl: {
        type: FIELD_TYPES.NESTED,
        label: "Tab 6 Image URL",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
};
